import styled from '@emotion/styled';

export const EmptySpace = styled.div`
  margin: auto;
  height: 30px;
  width: 30px;
`;
